module.exports = "/assets/side-events-hero@2x.png?GCiTQ8H";